export default __webpack_public_path__ + "static/media/Proposal.fdb80189.svg";